export const getSelectScriptColumns = (script: string) => {
  const scriptSemLineBreaks = script.replace(/[\r\n]/gm, ' ');

  return /(?:select)(.*?)(?=from)/i.exec(scriptSemLineBreaks);
};
